import { ArrowRight } from "lucide-react";
import { IMAGES, WHATSAPP_URL, handleWhatsAppClick } from "../../lib/site";

export const Couples = () => {
    return (
        <section id="casais" data-testid="couples-section" className="py-24 lg:py-32 relative overflow-hidden">
            <div
                aria-hidden
                className="absolute inset-y-0 right-0 w-1/2 bg-[#B7A6B0]/20 hidden lg:block"
            />
            <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center relative">
                <div className="lg:col-span-6 reveal">
                    <p className="overline mb-5">Terapia para casais</p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.6rem] leading-[1.05] text-[#2F2F2F]">
                        Reaprender a se encontrar
                        <span className="italic block text-[#9f1e1e]">— juntos.</span>
                    </h2>

                    <p className="mt-8 text-lg leading-relaxed text-[#2F2F2F]/85">
                        Há relações que pedem reparo. Outras pedem reinvenção. E, muitas vezes, pedem apenas
                        um espaço seguro onde os dois possam falar — e serem ouvidos — sem ruído.
                    </p>

                    <p className="mt-5 text-base leading-relaxed text-[#2F2F2F]/75">
                        Trabalho com casais que desejam restaurar a comunicação, sair de ciclos de mágoa,
                        atravessar crises de confiança, reaproximar a intimidade ou simplesmente cuidar do
                        relacionamento com a mesma seriedade com que cuidam de outras áreas importantes da
                        vida. A sessão é construída a partir de evidências clínicas e de um olhar profundamente
                        humano para a complexidade dos vínculos.
                    </p>

                    <ul className="mt-10 space-y-4">
                        {[
                            "Comunicação e escuta sem armadura",
                            "Conflitos recorrentes e reparação afetiva",
                            "Crises de confiança, ciúme e distanciamento",
                            "Reconstrução da intimidade e do projeto compartilhado",
                        ].map((item) => (
                            <li key={item} className="flex items-start gap-4">
                                <span className="mt-2 w-6 h-px bg-[#9f1e1e]" />
                                <span className="text-[15px] text-[#2F2F2F]/85 leading-relaxed">{item}</span>
                            </li>
                        ))}
                    </ul>

                    <a
                        href={WHATSAPP_URL}
                        onClick={handleWhatsAppClick}
                        data-testid="couples-cta"
                        className="btn-primary mt-12"
                    >
                        Iniciar terapia de casal
                        <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
                    </a>
                </div>

                <div className="lg:col-span-6 relative reveal reveal-delay-1">
                    <div className="editorial-frame relative aspect-[4/5] lg:aspect-[5/6]">
                        <img
                            src={IMAGES.process}
                            alt="Luara Ainá durante uma sessão"
                            className="w-full h-full object-cover"
                            data-testid="couples-image"
                        />
                    </div>
                    <div className="hidden lg:block absolute -bottom-10 -left-10 max-w-[280px] bg-[#F5F4F2] p-7 border-l-2 border-[#9f1e1e] shadow-xl">
                        <p className="font-display italic text-[1.45rem] leading-snug text-[#2F2F2F]">
                            “O amor maduro pede método, presença e tempo.”
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
